@if (availableFilters?.filters && availableFilters.filters.length > 0) {
  <div class="width-100" [ngClass]="{ topic: embeddedComponent }">
    @if (availableFilters.filterLabel) {
      <h3 class="advHeading">
        {{ availableFilters.filterLabel }}
        @if (embeddedComponent) {
          @if (expandCollapse) {
            <a tabindex="0" (click)="collapseRefine()" (keyup.enter)="collapseRefine()"
              ><span class="linkText">(Collapse )</span>
            </a>
          } @else {
            <a tabindex="0" (click)="expandRefine()" (keyup.enter)="expandRefine()"
              ><span class="linkText">(Expand )</span>
            </a>
          }
        }
      </h3>
    }
    @if ((!embeddedComponent || expandCollapse) && availableFilters.filters) {
      <div>
        <!-- Search by Date and Sort Order -->
        @for (filter of availableFilters.filters; track filter.filterId; let i = $index) {
          <div>
            @if (filter?.filterId === 1) {
              <div class="advSearchOptions">
                <label for="refineLibrarySelect">{{ filter?.title }} - </label>
                @if (filter?.dropdownFields) {
                  <select
                    id="refineLibrarySelect"
                    class="refineLibrarySelect"
                    [class]="'filter' + filter?.filterId"
                    (change)="selectFiltersDate($event)"
                  >
                    @for (option of filter?.dropdownFields; track option) {
                      <option [value]="option.value" [selected]="option.selected">
                        {{ option.name }}
                      </option>
                    }
                  </select>
                }
              </div>
            }
            @if (filter.filterId === 2) {
              <div class="advSearchOptions">
                <label for="refineLibrarySelect">{{ filter?.title }} - </label>
                @if (filter?.dropdownFields) {
                  <select
                    id="refineLibrarySelect"
                    class="refineLibrarySelect"
                    [class]="'filter' + filter?.filterId"
                    (change)="selectFiltersLibraries($event)"
                  >
                    @for (option of filter?.dropdownFields; track option) {
                      <option [value]="option.value" [selected]="option.selected">
                        {{ option.name }}
                      </option>
                    }
                  </select>
                }
              </div>
            }
            <div class="target-list row">
              @if (
                filter.filterId === 3 ||
                filter.filterId === 6 ||
                filter.filterId === 10 ||
                filter.filterId === 11 ||
                filter.filterId === 14 ||
                filter.filterId === 15
              ) {
                <custom-advanced-filters
                  class="width-100"
                  [tooltip]="tooltip(filter.filterId)"
                  [filter]="filter"
                  [embeddedComponent]="embeddedComponent"
                  [validators]="getValidators(filter.filterId)"
                  [groupValidators]="getGroupValidators(filter.filterId)"
                  [validationMessage]="getValidationMessages(filter.filterId)"
                  (filterSelectedEE)="selectFilter($event)"
                >
                </custom-advanced-filters>
              }
              @if (
                filter.filterId !== 1 &&
                filter.filterId !== 2 &&
                filter.filterId !== 3 &&
                filter.filterId !== 6 &&
                filter.filterId !== 10 &&
                filter.filterId !== 11 &&
                filter.filterId !== 14 &&
                filter.filterId !== 15
              ) {
                <advanced-filters
                  class="width-100"
                  [filter]="filter"
                  [embeddedComponent]="embeddedComponent"
                  (filterSelectedEE)="selectFilter($event)"
                >
                </advanced-filters>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
